module.exports = __webpack_public_path__ + "img/logo-getnet.1f680af4.jpg";